import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { Component } from 'react';
import { withTranslation } from 'react-i18next';
import SyntaxHighlighter from 'react-syntax-highlighter';
// @ts-expect-error TS7016: Could not find a declaration file for module
import * as hljs from 'react-syntax-highlighter/styles/hljs';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { STATIC_URL } from '../../../constants/env';
import Icon from '../../../components/Icon';
class Badge extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            mdCodeCopied: false,
        };
    }
    render() {
        const { repository, lastCommit, t } = this.props;
        const { mdCodeCopied } = this.state;
        const badgeUrl = !repository
            ? ''
            : STATIC_URL + '/badges/' + repository.vcs + '-' + repository.uuid.replace(/{|}/g, '') + '.svg';
        const dashboardUrl = location.href.replace(/\/settings$/, '');
        const mdCode = '[![' + t('siteName') + '](' + badgeUrl + ' "' + t('siteName') + '")](' + dashboardUrl + ')';
        return (_jsxs(_Fragment, { children: [_jsxs("div", { className: "mb-3", children: [_jsxs("span", { className: "mr-2", children: [t('badge'), ":"] }), repository && new Date(Number(lastCommit.updatedAt)) > new Date('2019-12-20T00:00:00') ? (_jsx("span", { children: _jsx("a", { href: dashboardUrl, target: "_blank", rel: "noreferrer", children: _jsx("img", { src: badgeUrl, alt: `${repository.getFullName()} badge` }) }) })) : (_jsxs("span", { children: [_jsx(Icon, { name: "spinner", pulse: true, fixedWidth: true, className: "mr-1" }), _jsxs("small", { children: ["(", t('badgeNewCommitRequired'), ")"] })] })), _jsx("div", { className: "mt-3", children: _jsx("small", { children: t('badgeDescription') }) })] }), _jsxs("div", { children: [_jsxs("span", { className: "float-right", children: [mdCodeCopied && _jsx("small", { className: "text-muted", children: t('copied') }), _jsx(CopyToClipboard
                                // @ts-expect-error TS2769: No overload matches this call.
                                , { 
                                    // @ts-expect-error TS2769: No overload matches this call.
                                    className: "ml-2 cursor--pointer", text: mdCode, onCopy: () => this.setState({ mdCodeCopied: true }), children: _jsx(Icon, { name: "copy-regular" }) })] }), t('source'), ":", _jsx(SyntaxHighlighter, { language: "markdown", style: hljs.solarizedLight, showLineNumbers: true, wrapLines: true, className: "report-detail__code", children: mdCode })] })] }));
    }
}
export default withTranslation()(Badge);
